export const types = <const>{
	mutations: {
		PRACOVNIK_SELECT_MAPPER: 'PRACOVNIK_SELECT_MAPPER',
		NAKLADOVE_STREDISKO_MAPPER: 'NAKLADOVE_STREDISKO_MAPPER',
		MECHANIK_MAPPER: 'MECHANIK_MAPPER',
		GET_PERM: 'getPerm',
		REKLAMNI_TEXTY_MAPPER: 'REKLAMNI_TEXTY_MAPPER',
		REKLAMNI_TEXTY_NV_MAPPER: 'REKLAMNI_TEXTY_NV_MAPPER',
		TYM_PRAC_MAPPER: 'tymPracMapper',
		TYM_PRAC_PT_MAPPER: 'TymPracPtMapper',
	},
	actions: {
		GET_UZIVATEL_PERM: 'getUzvatelPerm',
		SAVE_PERM: 'saveUserPermissions',
	},
};
